import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userApi } from '../api/userApi';
import type { UpdateUserRequest } from '../types/user';

/**
 * PATCH /api/eraf/users/{id} — 사용자 부분 갱신
 * 성공 시 상세/목록 쿼리 무효화
 */
export function useUpdateUser(id: number) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateUserRequest) => userApi.update(id, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['user-management', 'detail', id] });
      void qc.invalidateQueries({ queryKey: ['user-management', 'list'] });
    },
  });
}
